export const EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export const DOCUMENT_EXTENSIONS = '.pdf,.csv,.doc,.docx,.xlsx,.txt,.jpg,.jpeg,.png,.heic'

export const IMAGE_EXTENSIONS = '.jpg,.jpeg,.png'
